import * as s from './styles';

const AnimatedLoadingIcon = () => <s.AnimatedIcon />;

export default AnimatedLoadingIcon;
